<template>
    <div class="quarter-form">
        <div class="content-header">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <el-date-picker
                            v-model="weekValue"
                            type="year" placeholder="选择年" @change="selectYear">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formInline.period">
                        <el-option v-for="n in 4" :label="`第${n}季度`" :key="n" :value="n">第{{n}}季度</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCooperativeList">查询</el-button>
                    <el-button type="success" @click="downloadExcel">下载Excel</el-button>

                </el-form-item>
                <el-form-item>
                    <el-upload
                            multiple
                            :with-credentials="true"
                            :show-file-list="false"
                            class="upload-demo"
                            :action="importOkrParam"
                            :on-success="uploadSuccess"
                    >
                        <el-button size="small" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-form-item>
              <el-form-item>
                <el-upload
                    multiple
                    :with-credentials="true"
                    :show-file-list="false"
                    class="upload-demo"
                    :action="importOkrDingding"
                    :on-success="uploadSuccess"
                >
                  <el-button size="small" type="primary">上传OKR到钉钉<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="姓名" prop="userName"></el-table-column>
                <el-table-column label="季度" prop="periodName"></el-table-column>
                <el-table-column label="填写开始时间">
                    <template slot-scope="scope">
                        <span style="color: #41B883">{{scope.row.startEditTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="填写截止时间">
                    <template slot-scope="scope">
                        <span style="color: #41B883">{{scope.row.endEditTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="填写状态" prop="statusName"></el-table-column>
                <el-table-column v-if="formInline.classId!=3" label="报告状态" prop="reportStatus">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.reportStatus==1" type="success">已合格</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isEdit==1" type="danger" size="mini" @click="getCooperativeQues(scope.row)">修改</el-button>
                        <el-button v-if="scope.row.isEdit==0" :type="scope.row.isLeader==0||scope.row.isLeader==2?'warning':'success'"  size="mini" @click="getCooperativeQues(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    :hide-on-single-page="formInline.pageSize>=recordsTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-drawer
                :title="title"
                :visible.sync="drawerShow"
                direction="rtl"
                :before-close="handleClose" size="90%">
            <okr :param="paper" v-if="reFresh"  @drawClose="drawClose" ></okr>
        </el-drawer>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile,downloadExcelCooperative,importOkr,importOkrDingding} from '@/api/api';
    import {getRouterPageHash} from '@/api/http';
    import okr from "@/components/cooperative/okr";


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                quesList:[],
                weekValue:new Date(),
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:16,
                    year:'',
                    period:1,
                    userId:''
                },
                recordsTotal:0,
                drawerShow:false,
                editIs:0,
                voitIs:0,
                periodId:'',
                paperId:'',
                fileObjList:[],
                uploadFile:uploadCooperativeFile,
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                showDialog:false,
                dialogType:1,
                likeCommitContent:'',
                isLeader:0,
                importOkrParam:importOkr,
                importOkrDingding:importOkrDingding,
                title:'',
                updateFlag:0,
                reFresh:true,
                paper:{}
            }
        },
        props:['sectionClassId'],
        computed:{

        },
        watch:{
            title(){

                this.reFresh= false
                this.$nextTick(()=>{

                    this.reFresh = true
                })
            }
        },
        //挂载时候执行
        mounted() {
            this.formInline.classId=this.sectionClassId;
            this.getCooperativeList()
            this.selectYear(new Date())
            var currMonth=(new Date().getMonth() + 1);
            this.formInline.period=Math.floor( ( currMonth % 3 == 0 ? ( currMonth / 3 ) : ( currMonth / 3 + 1 ) ) );
        },
        components:{
            okr

        },
        methods: {
            //定义查询方法
            getCooperativeList() {
                this.$store.dispatch('initCooperativeList',this.formInline).then(res=>{
                    this.dataList = res.list
                    this.recordsTotal = res.total
                })
            },
            getCooperativeQues(obj) {
                console.log(obj)
                this.paper=obj;
                this.paper.period=this.formInline.period;
                this.title=obj.questionClassName+" (标*必填)"+" :【"+obj.userName+"】"+obj.periodName;
                this.drawerShow=true;
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeList()
            },
            handleClose(done) {
                this.quesList=[]
                this.voitIs = 0;
                this.isLeader = 0;
                this.editIs=0;
                this.periodId = '';
                this.paperId = '';
                this.fileObjList = [];
                this.getCooperativeList()
                done();
            },
            drawClose() {

                this.drawerShow=false;
                //console.log("123456789")
                this.getCooperativeList()

            },
            closeLikeDialog(){
                this.likeCommitContent = ''
            },
            isMonthKpi(val,item){
                console.log(val)
            },
            showCommentDialog(type){
                this.dialogType = type
                this.showDialog = true
            },
            selectYear(val){
                this.formInline.year = val.getFullYear()
            },

            targetValueInput(val){
                console.log(arguments)
            },
            downloadExcel(){
                let url = `${downloadExcelCooperative}?classId=${this.formInline.classId}&year=${this.formInline.year}&period=${this.formInline.period}&pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            uploadSuccess(res){
                if(res.status==500){
                    let data=res.value;
                    if(data==null){
                        data = [];
                        data= res.message.split(',');
                    }
                    let newDatas = [];
                    const h = this.$createElement;
                    //3.通过循环data数组，调用h方法，将每项值传给h,h('标签名',样式,具体内容)
                    for(let i in data){
                        //4.将data数据push进newDatas数组中
                        newDatas.push(h('p',null,data[i]));
                    };
                    this.$message({
                        showClose: true,
                        message:h('div',null, newDatas),
                        type: 'error'
                    });
                }
                if(res.status==400){
                    this.$message({
                        showClose: true,
                        message: "请上传excel文件",
                        type: 'error'
                    });
                }
                if(res.status==200){
                    //2.新建newDatas数组
                    let data=res.value;
                    if(data==null){
                        data = [];
                        data.push("保存成功,警告：已经被确认的目标不会导入");
                    }else{
                        data.unshift("警告：已经被确认的目标不会导入，以下保存失败：");
                    }
                    let newDatas = [];
                    const h = this.$createElement;
                    //3.通过循环data数组，调用h方法，将每项值传给h,h('标签名',样式,具体内容)
                    for(let i in data){
                        //4.将data数据push进newDatas数组中
                        newDatas.push(h('p',null,data[i]));
                    };

                    this.$message({
                        showClose: true,
                        message: h('div',null, newDatas),
                        type: 'success'
                    });
                }
            },

        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }
    .el-textarea__inner{
        min-height: 40px !important;
    }
    .quarter-form{
        .el-input-number{
            width: 100% !important;
        }

    }
    .drawer-wrap{
        .el-table__expanded-cell{
            background: #f5f5f5;
            text-align: left!important;
            padding: 7px 50px;
            .el-select,.el-input,.el-input-number{
                width: 240px;
            }
        }
    }
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/okrForm.vue